var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isUserRoleAssigned
    ? _c("NotFoundPage", {
        attrs: {
          "error-response": _vm.$t("noPermissions"),
          "button-is-visible": false,
        },
      })
    : _c(
        "div",
        { staticClass: "info-table-view__wrapper" },
        [
          _c(
            "pui-grid-container",
            { staticClass: "pl-0 pr-0" },
            [
              _c(
                "pui-grid-row",
                { staticStyle: { margin: "0" } },
                [
                  _c(
                    "pui-grid-column",
                    { staticClass: "pl-0 pr-0", attrs: { cols: 6 } },
                    [
                      _c("p", { staticClass: "info-table-view--heading" }, [
                        _vm._v(" " + _vm._s(_vm.$t("eventListTitle")) + " "),
                      ]),
                    ]
                  ),
                  _c(
                    "pui-grid-column",
                    {
                      staticClass: "pl-0 pr-0",
                      staticStyle: { "background-color": "#f9f9f9" },
                      attrs: { cols: 6 },
                    },
                    [
                      _vm.canDisplayManualUploadLink
                        ? _c(
                            "pui-button",
                            {
                              staticClass: "info-table-view--heading",
                              staticStyle: { float: "right" },
                              attrs: { icon: "upload", small: true },
                              on: {
                                click: function ($event) {
                                  return _vm.manualUpload.openUploadWindow()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("manualEventsUpload.linkToUpload")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("input", {
                        attrs: { hidden: "", type: "file", id: "uploadInput" },
                        on: { change: _vm.onFileLoaded },
                      }),
                      _c("br"),
                      _c("br"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "pui-lightbox",
            {
              ref: _vm.manualUpload.htmlDomRefKey,
              attrs: {
                "default-header-label": _vm.$t("manualEventsUpload.header"),
                "default-footer-confirm-label": _vm.$t(
                  "manualEventsUpload.confirmButton"
                ),
                "default-footer-cancel-label": _vm.$t("cancel"),
                "default-footer-confirm-disabled":
                  !_vm.manualUpload.canFinalize,
                "show-lightbox-close-icon": false,
                "fit-content": true,
                "on-cancel-callback": _vm.onCancel,
                "on-confirm-callback": _vm.finalizeUpload,
                "close-on-e-s-c": false,
              },
              scopedSlots: _vm._u([
                {
                  key: "lightbox-header",
                  fn: function () {
                    return [
                      _c("h2", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("manualEventsUpload.header")) +
                            " "
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm.manualUpload.response.statusCode === 200
                ? [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            _vm.manualUpload.canFinalize
                              ? "manualEventsUpload.successContent"
                              : "manualEventsUpload.errorContent"
                          )
                        )
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("manualEventsUpload.fileName") +
                            _vm.uploadItemName
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "manual-upload-scrollable" },
                      _vm._l(
                        _vm.manualUpload.validationItems,
                        function (item, index) {
                          return _c(
                            "p",
                            { key: index, staticClass: "pt-2" },
                            [
                              _c("pui-icon", {
                                attrs: {
                                  "icon-color": item.iconColor,
                                  "icon-name": item.iconName,
                                  size: "20",
                                },
                              }),
                              _vm._v(" " + _vm._s(item.message) + " "),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                  ]
                : [
                    _vm.manualUpload.response.message
                      ? _c("p", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.manualUpload.response.message) +
                              " "
                          ),
                        ])
                      : _c("p", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("manualEventsUpload.responseError")
                              ) +
                              " "
                          ),
                        ]),
                  ],
            ],
            2
          ),
          !_vm.isLoading
            ? _c("EventTable", {
                attrs: {
                  "vendor-options": _vm.vendorOptions,
                  "table-name": _vm.eventTableName,
                },
              })
            : _vm._e(),
          _vm.isLoading
            ? _c("pui-loader-spinner", {
                attrs: { title: `${_vm.$t("eventSubmittingModal.text")}...` },
              })
            : _vm._e(),
          _c("pui-pagination", {
            staticClass: "info-table-view__pagination",
            attrs: {
              "total-pages": _vm.pagination.totalPages,
              "range-of-pages": _vm.pagination.rangeOfPages,
            },
            on: { "changed:page": _vm.onPageChanged },
            model: {
              value: _vm.currentPagination,
              callback: function ($$v) {
                _vm.currentPagination = $$v
              },
              expression: "currentPagination",
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }